import request from '@/utils/http';
import { PFX, SRM_FILE_PRE } from '../../constant/constant.js';

// LSRM仓库人员列表
export const manageSearch = data => {
    return request({
        url: `${PFX}/supplierWarehouseWorkerSalaryConfirm/manageSearch`,
        method: 'post',
        data
    });
}

// LSRM端装卸人员工资确认导出接口
export const lsrmExport = data => {
    return request({
        url: `${SRM_FILE_PRE}/supplierWarehouseWorkerSalaryConfirm/lsrmExport`,
        method: 'post',
        data
    });
}

// 重推
export const rePush = data => {
    return request({
        url: `${PFX}/supplierWarehouseWorkerSalaryConfirm/rePush`,
        method: 'post',
        data
    });
}

// 操作记录
export const searchPushRecord = data => {
    return request({
        url: `${PFX}/supplierWarehouseWorkerSalaryConfirmPushRecord/search`,
        method: 'post',
        data
    });
}

// 重推校验
export const checkRePush = data => {
    return request({
        url: `${PFX}/supplierWarehouseWorkerSalaryConfirm/checkRePush`,
        method: 'post',
        data
    });
}

// 保存薪资未发原因
export const saveNoPaySalaryReason = data => {
    return request({
        url: `${PFX}/supplierWarehouseWorkerSalaryConfirm/saveNoPaySalaryReason`,
        method: 'post',
        data
    });
}

// 薪资未发流程列表
export const noPaySalaryReasonListByFlowId = data => {
    return request({
        url: `${PFX}/supplierWarehouseWorkerSalaryConfirm/noPaySalaryReasonList`,
        method: 'post',
        data
    });
}

// 查询分公司仓储经理信息接口
export const queryCompanyWarehouseManager = data => {
    return request({
        url: `${PFX}/contract/contractWarningMipInfo/queryCompanyWarehouseManager`,
        method: 'post',
        data
    });
}

// 查询闭环审批人
export const queryApproval = data => {
    return request({
        url: `${PFX}/supplierWarehouseWorkerSalaryConfirm/queryApproval`,
        method: 'post',
        data
    });
}

// 查询发薪预警详情
export const salaryDetail = params => {
    return request({
        url: `${PFX}/supplierWarehouseWorkerSalaryConfirm/detail`,
        method: 'get',
        params
    });
}

// 提交流程接口
export const supplierWarehouseWorkerSalaryConfirmAudit = data => {
    return request({
        url: `${PFX}/supplierWarehouseWorkerSalaryConfirmAudit/submit`,
        method: 'post',
        data
    });
}

// LSP仓库人员列表
export const supSearch = data => {
    return request({
        url: `${PFX}/supplierWarehouseWorkerSalaryConfirm/search`,
        method: 'post',
        data
    });
}

// LSP端装卸人员工资确认导出接口
export const lspExport = data => {
    return request({
        url: `${SRM_FILE_PRE}/supplierWarehouseWorkerSalaryConfirm/lspExport`,
        method: 'post',
        data
    });
}

// 装卸人员工资确认模板下载
export const templateDownload = () => {
    return request({
        url: `${SRM_FILE_PRE}/supplierWarehouseWorkerSalaryConfirm/templateDownload`,
        method: 'get',
    });
}
// 薪资未发原因流程信息
export const auditInfo = (params) => {
    return request({
        url: `${PFX}/supplierWarehouseWorkerSalaryConfirmAudit/auditInfo`,
        method: 'get',
        params
    });
}
// 待办明细列表
export const todoList = (params) => {
    return request({
        url: `${PFX}/supplierWarehouseWorkerSalaryConfirm/todoList`,
        method: 'get',
        params
    });
}
// 发送短信
export const sendSms = (data) => {
    return request({
        url: `${PFX}/supplierWarehouseWorkerSalaryConfirm/sendSms`,
        method: 'post',
        data
    });
}
// 待办明细导出
export const todoExport = (data = {}) => {
    return request({
        url: `/api-srm-file/supplierWarehouseWorkerSalaryConfirm/todoExport`,
        method: 'post',
        data
    });
};